import { CategoriesMenuActions } from '../actions';
import { CategoriesMenuData } from '../categories-menu-state';

export const initialState: CategoriesMenuData = { isOpen: false, nodes: {} };

export function reducer(
  state = initialState,
  action:
    | CategoriesMenuActions.CategoriesMenuLoadSuccess
    | CategoriesMenuActions.CategoriesMenuToggleOpen
    | CategoriesMenuActions.CategoriesMenuClearState
    | CategoriesMenuActions.CategoriesMenuSetState,
): CategoriesMenuData {
  switch (action.type) {
    case CategoriesMenuActions.LOAD_CATEGORIES_MENU_SUCCESS: {
      const { currentNodeId, ...data } = action.payload;

      return { ...state, nodes: { ...state.nodes, [currentNodeId]: data } };
    }

    case CategoriesMenuActions.CATEGORIES_MENU_TOGGLE_OPEN: {
      const isOpen = action.payload;
      if (typeof isOpen === 'undefined') {
        return { ...state, isOpen: !state.isOpen };
      }

      return { ...state, isOpen };
    }

    case CategoriesMenuActions.CATEGORIES_MENU_SET_STATE: {
      return action.payload;
    }

    case CategoriesMenuActions.CATEGORIES_MENU_CLEAR_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
